import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from '@mui/material';
import React from 'react';
import { useTranslation } from '../../../../services/translation/hooks/useTranslation';
export interface RadioButtonGroupProps {
  value: string;
  options: { value: string; label?: string }[];
  ariaLabel: string;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const RadioButtonGroup: React.FC<RadioButtonGroupProps> = ({
  value,
  options,
  ariaLabel,
  handleChange,
}) => {
  const { t } = useTranslation();
  const radioElement = (
    <Radio
      sx={{
        color: (theme) => theme.colors.darkTheme.grey.muted,
        '&.Mui-checked': {
          color: (theme) => theme.colors.common.bloomfieldGreen,
        },
      }}
    />
  );

  return (
    <Box sx={{ minWidth: 120 }}>
      <FormControl component='fieldset' fullWidth size='small'>
        <RadioGroup
          aria-label={ariaLabel}
          name={ariaLabel}
          value={value}
          onChange={handleChange}
        >
          {options.map((option) => (
            <FormControlLabel
              key={option.value}
              value={option.value}
              control={radioElement}
              label={t(option.label || option.value)}
            />
          ))}
        </RadioGroup>
      </FormControl>
    </Box>
  );
};
